import React from 'react';
import { ArrowRight } from 'lucide-react';

const ProjectCard = ({ project, language }) => {
  const handleViewMore = () => {
    if (project.url) {
      window.open(project.url, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <div className="card">
      <div className="card-header">
        <h3 className="card-title">{project.title}</h3>
        <p className="card-subtitle">{project.year}</p>
      </div>
      
      <p className="card-description">
        {language === 'ko' ? project.description.ko : project.description.en}
      </p>
      
      <div className="card-divider"></div>
      
             <div>
         <h4 style={{ fontSize: '0.9rem', fontWeight: 600, color: 'inherit', marginBottom: '1rem', textTransform: 'uppercase', letterSpacing: '0.5px' }}>
           {language === 'ko' ? '주요 타겟' : 'Target Markets'}
         </h4>
         <div className="tags">
           {project.targets.map((target, index) => (
             <span key={index} className="tag" style={{ 
               backgroundColor: `${target.color}15`, 
               color: target.color,
               borderColor: `${target.color}30`
             }}>
               {target.name}
             </span>
           ))}
         </div>
       </div>
      
      <button 
        className="btn" 
        onClick={handleViewMore}
        disabled={!project.url}
      >
        <span>View More</span>
        <ArrowRight size={16} />
      </button>
    </div>
  );
};

export default ProjectCard;
